import(/* webpackMode: "eager" */ "/app/apps/consumer/app/(public)/error.tsx");
